import { Box, Typography } from '@mui/material'
import { color } from 'config/color'
import { getMetricUnit } from 'containers/Usage/components/utils'
import type React from 'react'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import { UtilityIcon } from './UtilityIcon'
import { formatValue } from 'utils'

export interface UtilityItemType {
  type: string
  cost: string | number
  label?: string
  metric?: boolean | null
}

const UtilityItem: React.FC<UtilityItemType> = ({
  type,
  cost,
  label,
  metric
}) => {
  const isMobile = useMobileBreakpoints()

  const formattedCost =
    cost === ''
      ? ''
      : formatValue(String(cost), true, !metric)

  return (
    <Box
      display="flex"
      borderRadius={1}
      border={`solid 1px ${color.background[300]}`}
      width={isMobile ? 'auto' : '90%'}
      gap={2}
      p={2}
    >
      <UtilityIcon type={type} />
      <Box>
        <Typography
          fontSize={10}
          letterSpacing={1}
          color={color.grey[700]}
          textTransform="uppercase"
        >
          {label ?? type}
        </Typography>
        <Typography
          display="inline"
          fontSize={18}
          fontWeight={700}
          color={color.grey[900]}
        >
          {formattedCost}
        </Typography>
        <Typography display="inline">&nbsp;</Typography>

        {metric && (
          <Typography
            display="inline"
            fontSize={16}
            fontWeight={700}
            color={color.grey[700]}
          >
            {getMetricUnit(type)}
          </Typography>
        )}
      </Box>
    </Box>
  )
}
export default UtilityItem
